import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import TypographyCom from '../Typography';
import SvgComponent from '../SvgComponent';
import Icon from '../../assets/amenities_sprite2.svg';

const Heading = styled(TypographyCom)`
  margin-bottom: 24px;
`;

const Container = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.Neutral[300]};
  border-radius: 4px;
  flex-wrap: wrap;
  margin-bottom: 16px;
`;

const Card = styled.div`
  flex: 0 0 25%;
  margin: 16px 0px;
  height: 30px;
  padding-right: 5px;
  svg {
    width: 32px;
    height: 32px;
  }
  border-right: 1px solid ${({ theme }) => theme.colors.Neutral[300]};
  &:nth-child(4n + 4) {
    border: none;
    span:after {
      content: '';
      width: calc(400%);
      position: absolute;
      top: 46px;
      left: calc(-300%);
      border-bottom: 1px solid ${({ theme }) => theme.colors.Neutral[300]};
    }
  }
  @media screen and (max-width: 720px) {
    flex: 0 0 50%;
    &:nth-child(4n + 4) {
      span:after {
        width: calc(200%);
        left: calc(-100%);
      }
    }
    &:nth-child(4n + 2) {
      border: none;
      span:after {
        content: '';
        width: calc(200%);
        position: absolute;
        top: 46px;
        left: calc(-100%);
        border-bottom: 1px solid ${({ theme }) => theme.colors.Neutral[300]};
      }
    }
  }
  &:last-child {
    span:after {
      border: none;
    }
  }
`;

const Svg = styled(SvgComponent)`
  margin: 0px 15px;
  vertical-align: top;
`;

const AmenityName = styled(TypographyCom)`
  color: ${({ theme }) => theme.colors.TextBeta};
  vertical-align: top;
  line-height: 1.4;
`;

const ViewMore = styled(TypographyCom)`
  color: ${({ theme }) => theme.colors.Primary};
  padding: 9px;
  border-radius: 4px;
  margin: 0px auto;
  cursor: pointer;
`;

const svgArray = {
  'img-ic-24hr-backup-electricity': 1,
  'img-ic-ac-lobby': 1,
  'img-ic-cafeteria': 1,
  'img-ic-basket-ball-court': 1,
  'img-ic-amphitheater': 1,
  'img-ic-club-house': 1,
  'img-ic-cctv-cameras': 1,
  'img-ic-basement-car-parking': 1,
  'img-ic-covered-car-parking': 1,
  'img-ic-earthquake-resistant': 1,
  'img-ic-fire-safety': 1,
  'img-ic-gas-pipeline': 1,
  'img-ic-gated-community': 1,
  'img-ic-gym': 1,
  'img-ic-indoor-games': 1,
  'img-ic-intercom': 1,
  'img-ic-jogging-track': 1,
  'img-ic-landscaped-garden': 1,
  'img-ic-lift': 1,
  'img-ic-maintenance-staff': 1,
  'img-ic-play-area': 1,
  'img-ic-rain-water-harvesting': 1,
  'img-ic-health-facilities': 1,
  'img-ic-swimming-pool': 1,
  'img-ic-wifi-connection': 1,
  'img-ic-bank-atm': 1,
  'img-ic-broadband-internet': 1,
  'img-ic-dishwasher': 1,
  'img-ic-golf-course': 1,
  'img-ic-community-hall': 1,
  'img-ic-conference-room': 1,
  'img-ic-library': 1,
  'img-ic-burglar-alarm': 1,
  'img-ic-aroma-garden': 1,
  'img-ic-air-conditioner': 1,
  'img-ic-convenience-store': 1,
  'img-ic-badminton-court': 1,
  'img-ic-beds': 1,
  'img-ic-dining-table': 1,
  'img-ic-fire-alarm': 1,
  'img-ic-day-care-center': 1,
  'img-ic-kids-pool': 1,
  'img-ic-fountain': 1,
  'img-ic-greenery': 1,
  'img-ic-senior-citizen-plaza': 1,
  'img-ic-microwave': 1,
  'img-ic-modular-kitchen': 1,
  'img-ic-pets-park': 1,
  'img-ic-recreation-facilities': 1,
  'img-ic-service-lift': 1,
  'img-ic-world-class-open-air-fitness-gym': 1,
  'img-ic-pool-deck': 1,
  'img-ic-resting-pavilion': 1,
  'img-ic-movie-thetre': 1,
  'img-ic-refrigerator': 1,
  'img-ic-meeting-room': 1,
  'img-ic-security-personnel': 1,
  'img-ic-outdoor-dining-plaza': 1,
  'img-ic-tennis-court': 1,
  'img-ic-steam-room': 1,
  'img-ic-thar-road': 1,
  'img-ic-stove': 1,
  'img-ic-sofa': 1,
  'img-ic-therapeutic-walk': 1,
  'img-ic-temple': 1,
  'img-ic-solar-system': 1,
  'img-ic-trellis': 1,
  'img-ic-tv': 1,
  'img-ic-vastu-feng-shui-compliant': 1,
  'img-ic-visitor-parking': 1,
  'img-ic-wardrobes': 1,
  'img-ic-washing-machine': 1,
  'img-ic-waste-disposal': 1,
  'img-ic-water-filter': 1,
  'img-ic-water-storage': 1,
  'img-ic-yoga-center': 1,
  'img-ic-water-purifer': 1,
  'img-ic-chairs': 1,
  'img-ic-cubicle': 1,
  'img-ic-electrical-fittings': 1,
  'img-ic-storage-cupboards': 1
};

const Amenities = ({ data = [], isMobile, type }) => {
  const [viewMore, setViewMore] = useState(true);
  if (data.length === 0) return null;

  const baseLength = isMobile ? 4 : 8;
  const moreData = data.length > baseLength;
  return (
    <>
      <Heading tagName="h2" modifiers="h2">
        {type} Amenities
      </Heading>
      <Container className="dF">
        {data.slice(0, viewMore ? baseLength : data.length).map((item = '') => {
          const iconId = `img-ic-${item.replace('/', ' ').replace(/\s+/g, '-')}`.toLowerCase();
          const firstSpaceChar = item.indexOf(' ');
          const name =
            item.length < 15 || (firstSpaceChar > 0 && firstSpaceChar < 14)
              ? item
              : `${item.slice(0, 14)}- ${item.slice(14)}`;
          return (
            <Card className="dFA pR" key={item}>
              <Svg svgSprite={Icon} id={svgArray[iconId] ? iconId : 'img-ic-default'} />
              <AmenityName tagName="span" modifiers="bt3" title={item}>
                {name}
              </AmenityName>
            </Card>
          );
        })}
      </Container>
      {moreData && (
        <ViewMore
          onClick={() => setViewMore(state => !state)}
          className="taC"
          modifiers={['bt2', 'medium']}
        >
          {' '}
          {viewMore ? `${data.length - baseLength} More Amenities` : 'View Less'}{' '}
        </ViewMore>
      )}
    </>
  );
};

Amenities.propTypes = {
  data: PropTypes.array,
  isMobile: PropTypes.bool,
  type: PropTypes.oneOf(['Society', 'Flat']),
  className: PropTypes.string
};

Amenities.defaultProps = {
  data: [],
  type: 'Society'
};

export default Amenities;
